import React from 'react';
import AboutUsMediaCoverageCard from 'components/about-us-page/media-coverage/card';
import styles from './style.module.scss';

import type { MediaCoverage } from 'data/named-content/types';

export default function AboutUsMediaCoverage({ mediaCoverage }: { mediaCoverage: MediaCoverage[] }) {
  return (
    <div className={styles.media}>
      <div className={styles.container}>
        <h2>Media Coverage Highlights</h2>
        <div className={styles.cards}>
          {mediaCoverage.map(coverage => (
            <AboutUsMediaCoverageCard key={coverage.title} title={coverage.title} link={coverage.link} logoSrc={coverage.logoSrc} imageSrc={coverage.imageSrc} date={coverage.date} />
          ))}
        </div>
      </div>
    </div>
  );
}
